import { Close, FilterList } from '@mui/icons-material';
import { Button } from '@mui/material';
import clsx from 'clsx';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { FC } from 'react';

interface IFiltersButtons {
  hasAppliedFilters: boolean;
  isDisabled?: boolean;
  handleApplyFilters: () => void;
  handleResetFilters: () => void;
}

export const FiltersButtons: FC<IFiltersButtons> = ({
  isDisabled,
  hasAppliedFilters,
  handleApplyFilters,
  handleResetFilters
}) => {
  const classes = useStyles();
  return (
    <>
      <Button
        color="primary"
        variant="contained"
        className={classes.button}
        disabled={isDisabled}
        startIcon={<FilterList />}
        onClick={handleApplyFilters}
      >
        Apply Filters
      </Button>
      {hasAppliedFilters && (
        <Button
          color="inherit"
          className={clsx(classes.button, classes.resetButton)}
          variant="contained"
          disabled={isDisabled}
          startIcon={<Close />}
          onClick={handleResetFilters}
        >
          Reset
        </Button>
      )}
    </>
  );
};

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  button: {
    marginTop: 4,
    marginBottom: 4,
    height: 40,
    textTransform: 'capitalize',
    width: '100%',
    '@media (min-width: 400px)': {
      width: '48%'
    },
    [theme.breakpoints.up('sm')]: {
      width: 'auto'
    }
  },
  resetButton: {
    '@media (min-width: 400px)': {
      marginLeft: 11
    },
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1)
    }
  }
}));
